import type { PrintPayloadStrategy, PrinterInterfaceKey } from './types'
import { PrintPayloadStrategyV3 } from './PrintPayloadStrategyV3'
import { PrintPayloadStrategyLegacy } from './PrintPayloadStrategyLegacy'
import { V3_MIN_VERSION } from '~/utils/printerVersion'

export type { PrintPayloadStrategy, PrintPayloadOptions, PrintReceiptSource } from './types'
export { PrintPayloadStrategyV3 } from './PrintPayloadStrategyV3'
export { PrintPayloadStrategyLegacy } from './PrintPayloadStrategyLegacy'
export { buildSummarySections } from './derive/summarySections'

const STRATEGIES: Record<PrinterInterfaceKey, PrintPayloadStrategy> = {
  v3: PrintPayloadStrategyV3,
  legacy: PrintPayloadStrategyLegacy,
}

/**
 * Resolve by the printer service's numeric AppVersion ("331" -> 331).
 *
 * Keyed on the number rather than a boolean so a future interface can be added
 * here without touching any call site. 0 (detection failed / printer offline)
 * resolves to `legacy`, the safe default: a legacy payload carries totals a V5
 * renderer simply ignores, whereas a V3 payload on a legacy renderer prints no
 * totals at all.
 */
export const getPrintPayloadStrategy = (appVersion: number): PrintPayloadStrategy =>
  (Number(appVersion) || 0) >= V3_MIN_VERSION ? STRATEGIES.v3 : STRATEGIES.legacy

export const getPrintPayloadStrategyByKey = (key: PrinterInterfaceKey): PrintPayloadStrategy =>
  STRATEGIES[key] || STRATEGIES.legacy
